module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"service.check.list_yes":"ใช่","service.check.list_no":"ไม่ใช่","service.check.list_work":"ได้","service.check.list_not_work":"ไม่ได้","service.check.list_no_value":"ไม่ได้ทดสอบ","service.check.list_unspecified":"ไม่ระบุ"}}')
  delete Component.options._Ctor
}
